@import "../../variables.scss";

.searchBox {
  &__wrapper {
    position: relative;
  }
  &__input {
    position: relative;
    padding-left: 32px;
    width: 280px;
    height: 40px;
    border: none;
    border: 1px #d9d9d9 solid;
    border-radius: 3px;
    color: black;
    font-weight: bold;

    &::placeholder {
      color: black;
      font-weight: bold;
    }
  }
  &__magnifier {
    position: absolute;
    left: 10px;
    top: 13px;
  }
  &__close {
    position: absolute;
    left: 256px;
    top: 15px;
    cursor: pointer;
  }
}
